// extracted by mini-css-extract-plugin
module.exports = {"message":"servererror_message__3KSMX"};